module.exports = __webpack_public_path__ + "static/profile-photo-f71a2456a54f72ebcda995b46a8fd4ce.jpeg";